import React, { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import { UPLOAD_BUTTON_LABEL } from '../../constants'
import { CreationToolsContext } from '../../manager'
import CreationToolStatus from '../../types/status'
import CreationToolUserRestriction from '../../types/user-restriction'
import UploadButtonComponent from '../upload-button'
import { CreationToolUploadContext } from './manager'

const Button = styled(UploadButtonComponent)`
    box-sizing: content-box;
    margin: 0 -10px;
`

const CreationToolUploadButton = () => {
    const { userRestrictionAccess } = useContext(CreationToolsContext)
    const { upload, uploadSources, pause, status, username } = useContext(CreationToolUploadContext)
    const [canUpload, setCanUpload] = useState<boolean>(false)
    const isLoggedIn = userRestrictionAccess.indexOf(CreationToolUserRestriction.LoggedInOnly) > -1
    const successfulUploadCount = uploadSources.filter(src => !!src.uploadedId).length
    const showChannelButton = username && uploadSources.length > 1 && successfulUploadCount === uploadSources.length
    const total = uploadSources.filter(source => !source.error).length
    const current = Math.min(uploadSources.filter(source => !!source.uploadedId).length + 1, total)
    const statusLabel = CreationToolStatus.description(status)
    const isUploading = status !== CreationToolStatus.Idle

    useEffect(() => {
        const readySources = uploadSources.filter(source => !source.error && !source.uploadedId)
        if (isLoggedIn && status === CreationToolStatus.Idle && readySources.length > 0) {
            setCanUpload(true)
        } else {
            setCanUpload(false)
        }
    }, [uploadSources, status, isLoggedIn])

    const getButtonLabel = (): string => {
        if (isUploading) {
            return `${statusLabel}${total > 1 ? ` ${current} of ${total}` : ``}`
        }
        if (showChannelButton) {
            return `Open Channel`
        }
        return UPLOAD_BUTTON_LABEL
    }

    return (
        <Button
            {...{
                isUploading,
                disabled: !showChannelButton && !canUpload,
                progress: isUploading ? current / total : 0,
                url: showChannelButton ? `/channel/${username}` : '',
                onPause: total > 1 ? pause : undefined,
                onClick: showChannelButton ? undefined : () => upload(uploadSources),
            }}
        >
            {getButtonLabel()}
        </Button>
    )
}

export default CreationToolUploadButton
